import { useState } from 'react';
import { useAuth } from '../context/AuthContext';

interface GoogleSignInButtonProps {
  onSuccess?: () => void;
  onClick?: () => void;
  isLoading?: boolean;
  className?: string;
}

export const GoogleSignInButton = ({ 
  onSuccess, 
  onClick, 
  isLoading: externalLoading, 
  className = '' 
}: GoogleSignInButtonProps) => {
  const { signInWithGoogle } = useAuth();
  const [internalLoading, setInternalLoading] = useState(false);
  
  // Use external loading state if provided, otherwise use internal state
  const isLoading = externalLoading !== undefined ? externalLoading : internalLoading;

  const handleGoogleSignIn = async () => {
    // If external onClick is provided, call it first
    if (onClick) {
      onClick();
    }

    // Always handle the OAuth flow (whether onClick was provided or not)
    try {
      setInternalLoading(true);
      const result = await signInWithGoogle();
      if (result.success) {
        // OAuth redirects to Google, so we don't call onSuccess here
        // The success will be handled by the callback component
      }
    } catch (error) {
      console.error('Google sign in error:', error);
      setInternalLoading(false);
    }
  };

  return (
    <button
      onClick={handleGoogleSignIn}
      disabled={isLoading}
      className={`w-full flex items-center justify-center gap-3 px-4 py-2 bg-audafact-surface-2 border border-audafact-divider rounded-lg text-audafact-text-primary hover:bg-audafact-surface-1-enhanced transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      {isLoading ? (
        <>
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-audafact-accent-cyan"></div>
          <span className="font-medium">Connecting...</span>
        </>
      ) : (
        <>
          <svg className="w-5 h-5" viewBox="0 0 24 24">
            <path
              fill="#4285F4"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            />
            <path
              fill="#34A853"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            />
            <path
              fill="#FBBC05"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            />
            <path
              fill="#EA4335"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            />
          </svg>
          <span className="font-medium">Continue with Google</span>
        </>
      )}
    </button>
  );
}; 